import { useContext } from 'react';

import { Globals } from '@h2/globals';

const useIsUserOver13 = () => {
  const { userProfile } = useContext(Globals);

  return !userProfile?.isBelow13;
};

export { useIsUserOver13 };